import {
  useParamsWithDefault,
  useSearchWithDefault,
} from "@smart/itops-hooks-dom";

import { SubmissionLoadView } from "../components";

export const Submission = () => {
  const submissionInfo = useParamsWithDefault((p) => ({
    id: p.id || "",
  }));

  const { format } = useSearchWithDefault((p) => ({
    format: p.get("format") || "",
  }));

  return (
    <SubmissionLoadView {...submissionInfo} hideTeam={format === "portal"} />
  );
};
